import script from "./NewsPageBodyEmptyNews.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyEmptyNews.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyEmptyNews.vue?vue&type=style&index=0&id=2ed234e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed234e2"]])

export default __exports__